import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=7c4a148a&scoped=true"
import script from "./Static.vue?vue&type=script&lang=js"
export * from "./Static.vue?vue&type=script&lang=js"
import style0 from "./Static.vue?vue&type=style&index=0&id=7c4a148a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a148a",
  null
  
)

export default component.exports